export interface TourStep {
  target: string;
  content: string;
  disableBeacon?: boolean;
}

type Locale = {
  back?: string;
  close?: string;
  last?: string;
  next?: string;
  skip?: string;
};

type Tour = {
  steps: TourStep[];
  locale?: Locale;
  mixPanelEventName?: string;
};

export type TourObject = {
  [key: string]: Tour;
};

const TourConfigs: TourObject = {
  group_and_concurrent: {
    steps: [
      {
        target: '.group_and_concurrent',
        content: 'Find all of our Group & Concurrent content in one place, including games and exercise videos',
        disableBeacon: true,
      },
    ],
    locale: {
      last: 'Got it!',
      next: 'Got it!',
    },
    mixPanelEventName: 'Therapy_RestoreSkillsUI_GroupAndConcurrentTab_View',
  },
};

export default TourConfigs;
